import { ValidationObserver, ValidationProvider } from 'vee-validate';
import store from '../../store'


export default {
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            email: null,
            isShowModal: false
        }
    },
    computed: {
        isDisabled() {
            return !this.email;
        }
    },
    methods: {
        async sendEmail() {
            let email = this;
            const prueba = await SendEmail.sendEmailCode();

            email = email.toLowerCase();
            store.dispatch("auth/saveEmail", this.email);
        }
    }
}